<template>
  <header>
    <nav class="nav">
      <div class="navbar__brand">
        
          <img src="../../assets/img/ai-svgrepo-com.svg" alt="AI" class="navbar__ai_logo" @click="goToHome">
        <router-link to="/" class="navbar__textbrand">Bella Digital Twins Contest (HKU)<br>校花數位分身大賽 (香港大學)</router-link>
        <p class="navbar__textbrand--sub">powered by TAMEE</p>
        <!-- TAMEE logo -->
        <img src="../../assets/img/tameedot_100.png" alt="TAMEE logo" class="navbar__logo" style="margin-left: 5px;">
      </div>
     

      <ul class="navbar__nav navbar__nav--right" v-if="!isAuthorized">
      
        <li class="nav__item">
          <router-link to="/login" class="nav__link nav__link--rounded"
            >Login</router-link
          >
        </li>
        <li class="nav__item">
          <router-link to="/register" class="nav__link nav__link--rounded"
            >Register</router-link
          >
        </li>
      </ul>
<!-- && currentRoute !== 'Front'" -->
      <SignedInLinks 
        v-if="isAuthorized" 
        :logout="logout" 
        :user="user" 
      />
      
    </nav>
    <nav class="snav" v-bind:class="{ 'snav--shown': navToggleState }">
      <Particle name="particlejs-nav" />
      <ul class="snav__nav" v-if="!isAuthorized">
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/" class="nav__link">🙎🏻‍♀️ Bellas</router-link>
        </li>
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/about" class="nav__link">About</router-link>
        </li>
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/login" class="nav__link nav__link--rounded"
            >Login</router-link
          >
        </li>
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/register" class="nav__link nav__link--rounded"
            >Register</router-link
          >
        </li>
      </ul>

      <ul class="snav__nav" v-if="isAuthorized">
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/" class="nav__link">Home</router-link>
        </li>
        
        <li @click="this.closeSideNav" class="snav__item">
          <router-link to="/voting" class="nav__link">🗳️ Voting</router-link>
        </li>
        
        <li @click="this.closeSideNav" class="snav__item">
          <router-link
            v-if="Object.keys(user).length > 0"
            :to="{ name: 'UserProfile', params: { handle: user.handle } }"
            class="nav__link nav__link--rounded"
            >{{ user.handle }}</router-link
          >
        </li>
        
        <li @click="this.closeSideNav" class="snav__item">
          <button
            @click.prevent="logout"
            class="nav__link nav__link nav__link--rounded"
          >
            Logout
          </button>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Particle from "./Particle.vue";
import SignedInLinks from "./SignedInLinks.vue";

export default {
  name: "Navbar",
  components: {
    Particle: Particle,
    SignedInLinks,
  },
  data: function () {
    return {
      navToggleState: false,
    };
  },
  computed: {
    ...mapGetters(["getUserData", "isAuthorized"]),
    user() {
      return this.getUserData;
    },
    currentRoute() {
      return this.$route.name; // Get the current route name
    },
  },
  methods: {
    ...mapActions(["toggleAuthState"]),
    closeSideNav() {
      this.navToggleState = false;
    },
    logout() {
      if (localStorage.getItem("authToken")) {
        // Import and use the new auth token clearer
        import("../../utils/authToken").then(({ setAuthTokenWithCookie }) => {
          setAuthTokenWithCookie(null); // This will clear both localStorage and cookies
        });
        localStorage.clear();
        this.$store.dispatch("toggleAuthState", false);
        this.$router.push({ name: "Login" });
      }
    },
    goToHome() {
      this.$router.push('/');
    },
  },
  created() {
    if (localStorage.getItem("authToken")) {
      this.$store.dispatch("toggleAuthState", true);
    } else {
      localStorage.clear();
      this.$store.dispatch("toggleAuthState", false);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/components/navbar.scss";

.nav{
  @media (max-width: 768px) {
    
    font-size: 12px;
  }
}
.navbar__textbrand--sub {
  font-size: 12px;
  color: #666;
  padding-left: 10px;
  @media (max-width: 768px) {
    font-size: 8px;
  }
}
.navbar__logo {
  width: 20px;
  height: 20px;
}
.navbar__ai_logo {
  width: 50px;
  height: 50px;
}

.navbar__textbrand {
  font-size: 24px;
  font-weight: bold;
  @media (max-width: 768px) {
    font-size: 9px;
  }
}

header {
  position: sticky !important;
  @media (max-width: 1390px) {
    .nav {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }
  }
}
</style>
